import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import httpClient from '@/lib/httpClient';
import type { DefaultQueryError } from '../types';
import type { CityId, HubsData, LatLng } from './types';

export const getHubsFn = async (params: LatLng | CityId, rentType?: string) => {
  const paramsGetHubs = {} as LatLng | CityId;

  if ((params as CityId).city_id) {
    (paramsGetHubs as CityId).city_id = (params as CityId).city_id;
  }
  if ((params as LatLng).lat && (params as LatLng).lng) {
    (paramsGetHubs as LatLng).lat = (params as LatLng).lat;
    (paramsGetHubs as LatLng).lng = (params as LatLng).lng;
  }
  const response = await httpClient.get<HubsData>(apiRoutes.place.hubs, {
    params: { ...paramsGetHubs, service_type: rentType },
  });
  return response.data;
};

export const useGetHubs = (
  params: LatLng | CityId,
  opts?: UseQueryOptions<HubsData, DefaultQueryError>,
  rentType?: string
) =>
  useQuery<HubsData, DefaultQueryError>(
    [apiRoutes.place.geocode_reverse, { ...params, rentType }],
    () => getHubsFn(params, rentType),
    opts
  );
